module.exports = __webpack_public_path__ + "static/img/智慧仓储.b560dfef.jpeg";